module.exports = __webpack_public_path__ + "static/media/BG.378dea18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BG.svg
// module id = 2111
// module chunks = 7